import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { fixRouteParam } from '@src/utils';

@Component({
  selector: 'app-registration-page',
  templateUrl: './registration-page.component.html',
  styleUrls: ['./registration-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationPageComponent extends BaseResizableComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  associationId?: string;

  override ngOnInit(): void {
    super.ngOnInit();

    this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(async params => {
      this.associationId = fixRouteParam(params.get('associationId'));
      this.cdr.markForCheck();
    });
  }

  onSaveRegistrationUser(): void {
    this.router.navigate(['login']);
  }
}
